import actions from './actions';
const initstate = {
  contacts: [],
  contact: {},
  isDelete: false,
};

export default function cardReducer(state = initstate, { type, ...action }) {
  switch (type) {
    case actions.GET_CONTACT_REDUCER: {
      return {
        ...state,
        contacts: action,
        isDelete: false,
      };
    }
    case actions.GET_BY_ID_CONTACT_REDUCER: {
      return {
        ...state,
        isDelete: false,
        contacts: action,
      };
    }
    case actions.UPDATE_SUCCESS: {
      return {
        ...state,
        isDelete: false,
      };
    }
    case actions.DELETE_SUCCESS: {
      return {
        ...state,
        isDelete: true,
      };
    }
    default:
      return state;
  }
}
